import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MatRippleModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AccountDataValidatorDirective, AddressFormComponent, AddressItemComponent, AddressReactiveFormComponent, AuditComponent, ContactFormComponent, CostFormComponent, EditorMatFormControlDirective, EmptyStringResetDirective, IbanValidatorDirective, MOMENT_DATE_FORMATS, NativeElementInjectorDirective, PersonalDataFormComponent, PersonalDataReactiveFormComponent, PhoneFormComponent, PriceFormComponent, SepaFormComponent } from '@app/core';
import { CustomerConnectionFormComponent, CustomerLineDetailsFormComponent } from '@app/customers-base';
import { AdditionalNumberBlocksDialogComponent, AdditionalNumbersDialogComponent, ExportNumberDialogComponent, PhoneBookEntryFormComponent } from '@app/orders-base';
import { VdCommonModule, VdFormsModule, VdLayoutModule, VdMediaModule, VdMenuModule, VdSelectModule } from '@messaia/cdk';
import { EditorModule } from '@tinymce/tinymce-angular';
import * as moment from 'moment';

@NgModule({
    exports: [
        CdkTableModule,
        MatDatepickerModule,
        MatChipsModule,
        MatButtonModule,
        MatInputModule,
        MatIconModule,
        MatListModule,
        MatMomentDateModule,
        MatCardModule,
        MatRippleModule,
        MatSelectModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatExpansionModule,
        MatSortModule,
        MatTableModule,
        MatProgressSpinnerModule
    ]
})
export class MaterialModule { }

@NgModule({
    exports: [
        VdCommonModule,
        VdLayoutModule,
        VdMediaModule,
        VdSelectModule,
        VdMenuModule,
        VdFormsModule,
    ]
})
export class VdModule { }

const SHARED_DECLARATION = [
    AddressFormComponent,
    AddressReactiveFormComponent,
    AddressItemComponent,
    SepaFormComponent,
    PersonalDataFormComponent,
    PersonalDataReactiveFormComponent,
    PriceFormComponent,
    CostFormComponent,
    PhoneFormComponent,
    ContactFormComponent,
    AuditComponent,
    NativeElementInjectorDirective,
    EmptyStringResetDirective,
    IbanValidatorDirective,
    AccountDataValidatorDirective,
    EditorMatFormControlDirective,
    PhoneBookEntryFormComponent,
    CustomerLineDetailsFormComponent,
    CustomerConnectionFormComponent,
    AdditionalNumbersDialogComponent,
    AdditionalNumberBlocksDialogComponent,
    ExportNumberDialogComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        EditorModule,
        VdModule,
        // FaqsModule,
    ],
    declarations: [SHARED_DECLARATION],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        EditorModule,
        VdModule,
        // FaqsModule,
        SHARED_DECLARATION
    ],
    providers: [
        MomentDateAdapter,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        }
    ]
})
export class SharedModule {

    /**
     * Constructor
     * @param dateAdapter
     */
    constructor(private adapter: MomentDateAdapter) {
        /* Set datetime language to de-DE */
        this.adapter.setLocale('de');

        /* Set moment locale */
        moment.locale('de');
    }
}